// extracted by mini-css-extract-plugin
export default {"expenseWidget":"ExpenseWidget_expenseWidget__AgkqM","expenseWidgetTitle":"ExpenseWidget_expenseWidgetTitle__JVi4h","expenseWidgetAmount":"ExpenseWidget_expenseWidgetAmount__O-4C2"};